var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1663 5.45801V9.93276C18.1663 10.5395 18.1663 10.8428 18.2844 11.0746C18.3883 11.2784 18.554 11.4442 18.7578 11.548C18.9896 11.6661 19.293 11.6661 19.8997 11.6661H24.3744M12.7497 20.3327L14.9163 22.4993L19.7913 17.6243M18.1663 5.16602H12.533C10.7128 5.16602 9.80275 5.16602 9.10754 5.52024C8.49601 5.83183 7.99883 6.32902 7.68724 6.94055C7.33301 7.63576 7.33301 8.54585 7.33301 10.366V21.6327C7.33301 23.4529 7.33301 24.3629 7.68724 25.0582C7.99883 25.6697 8.49601 26.1669 9.10754 26.4785C9.80275 26.8327 10.7128 26.8327 12.533 26.8327H19.4663C21.2865 26.8327 22.1966 26.8327 22.8918 26.4785C23.5033 26.1669 24.0005 25.6697 24.3121 25.0582C24.6663 24.3629 24.6663 23.4529 24.6663 21.6327V11.666L18.1663 5.16602Z",
    stroke: "#26CB55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadFileIcon);
export default __webpack_public_path__ + "static/media/loadFile-icon.82a0c4c9713215b89e9000df71e9aa7d.svg";
export { ForwardRef as ReactComponent };